import React, { useEffect, useState } from 'react';
import { IPopoverGerenalPlacements } from '../../interfaces';
import { EpIcon } from '../EpIcon';
import { EpPopover } from '../EpPopover';

import './EpHelper.scss';

interface EpHelperProps {
  helperId: string;
  popoverId: string;
  popoverHostId: string;
  popoverContentType?: 'text' | 'simple-html';
  popoverTitle?: string;
  popoverTitleHasHtml?: boolean;
  popoverText?: string;
  popoverPlacement?: 'auto' | IPopoverGerenalPlacements;
  customClasses?: string;
}

export const EpHelper: React.FC<EpHelperProps> = ({
  helperId,
  popoverId,
  popoverHostId,
  popoverContentType = 'text',
  popoverTitle,
  popoverTitleHasHtml = false,
  popoverText,
  popoverPlacement = 'auto',
  customClasses,
}) => {
  const [isMediumScreen, setIsMediumScreen] = useState<boolean>(
    window.innerWidth <= 765,
  );

  useEffect(() => {
    const handleResize = () => {
      setIsMediumScreen(window.innerWidth <= 765);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className={`ep-helper__wrapper ${customClasses ? customClasses : ''}`}>
      <EpPopover
        popoverId={popoverId}
        popoverHostId={popoverHostId}
        popoverContentType={popoverContentType}
        popoverEventType="hover"
        popoverTitle={popoverTitle}
        popoverTitleHasHtml={popoverTitleHasHtml}
        popoverPlacement={isMediumScreen ? 'auto' : popoverPlacement}
        popoverText={popoverText}
        triggerPopover={
          <div id={helperId} className="ep-helper popover__trigger">
            <div className="ep-helper__icon">
              <EpIcon iconName="SolidInfoCircle" iconSize={16}></EpIcon>
            </div>
          </div>
        }
      ></EpPopover>
    </div>
  );
};
